@for (line of getLines(); track line; let last = $last) { {{ line }}@if (!last) {
<br />
} }
